function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as v, jsx as a } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as t } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: l , size: c = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const r = s(), o = l !== null && l !== void 0 ? l : r ? t.colors.inverse : t.colors.neutralHigh, { skinName: m  } = h();
    return m.match(/^o2/i) ? /* @__PURE__ */ v("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: o,
                d: "M21.176 14.98a.371.371 0 00-.52-.088.372.372 0 00-.087.52 3.708 3.708 0 01-.404 4.76c-.056-.736-.568-1.336-1.352-1.644.356-.34.576-.808.576-1.336 0-1.02-.836-1.856-1.855-1.856-1.02 0-1.855.836-1.855 1.856 0 .528.227 1.004.583 1.344-.775.308-1.28.916-1.327 1.66a3.69 3.69 0 01-1.1-2.632c0-2.04 1.66-3.7 3.699-3.7.204 0 .372-.16.372-.372a.364.364 0 00-.372-.372c-.268 0-.536.024-.792.072a.113.113 0 01-.009-.028.114.114 0 00-.007-.028l-1.895-3.28A4.445 4.445 0 0011.98 2C9.545 2 7.554 3.992 7.554 6.444c0 1.368.624 2.592 1.595 3.408l-1.895 3.28a.092.092 0 00-.009.028l-.007.028A4.436 4.436 0 002 17.556 4.444 4.444 0 006.446 22a4.452 4.452 0 004.427-4.072h2.259A4.44 4.44 0 0017.558 22 4.446 4.446 0 0022 17.556a4.477 4.477 0 00-.824-2.576zM10.888 6.072a1.11 1.11 0 011.108-1.108c.608 0 1.108.504 1.108 1.108a1.11 1.11 0 01-1.108 1.108 1.103 1.103 0 01-1.108-1.108zm1.108 4.084c-.68 0-1.32-.188-1.863-.512V9.2c0-.736.783-1.272 1.863-1.272 1.092 0 1.887.536 1.887 1.272v.428c-.551.332-1.2.528-1.887.528zM8.297 6.444c0-2.04 1.66-3.7 3.699-3.7a3.703 3.703 0 012.615 6.316c-.056-.736-.568-1.336-1.352-1.644.356-.34.576-.808.576-1.336 0-1.02-.835-1.856-1.855-1.856s-1.855.836-1.855 1.856c0 .528.228 1.004.584 1.344-.76.3-1.264.908-1.312 1.652a3.707 3.707 0 01-1.1-2.632zM12 10.892a4.43 4.43 0 002.243-.616l1.795 3.108a4.452 4.452 0 00-2.906 3.796h-2.26a4.42 4.42 0 00-2.906-3.796l1.79-3.108a4.396 4.396 0 002.244.616zm-7.425 9.86v-.444c0-.736.784-1.272 1.863-1.272 1.092 0 1.887.536 1.887 1.272v.428a3.655 3.655 0 01-1.887.528 3.761 3.761 0 01-1.863-.512zm1.867-4.676c.604 0 1.108.504 1.108 1.108 0 .604-.504 1.108-1.108 1.108a1.113 1.113 0 01-1.107-1.108 1.11 1.11 0 011.107-1.108zm2.627 4.096c-.056-.736-.568-1.336-1.351-1.644.356-.34.575-.808.575-1.336 0-1.02-.835-1.856-1.855-1.856a1.846 1.846 0 00-1.263 3.192c-.776.308-1.28.916-1.328 1.66a3.69 3.69 0 01-1.1-2.632c0-2.04 1.66-3.7 3.7-3.7a3.704 3.704 0 012.622 6.316zm8.48-4.096c.605 0 1.108.504 1.108 1.108 0 .604-.503 1.108-1.107 1.108a1.113 1.113 0 01-1.108-1.108 1.11 1.11 0 011.108-1.108zm-1.858 4.676v-.444c0-.736.783-1.272 1.863-1.272 1.091 0 1.887.536 1.887 1.272v.428a3.66 3.66 0 01-1.887.528 3.693 3.693 0 01-1.863-.512z"
            }),
            /* @__PURE__ */ a("path", {
                fill: o,
                d: "M19.405 14.592a.736.736 0 100-1.472.736.736 0 000 1.472z"
            })
        ]
    })) : /* @__PURE__ */ a("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ a("path", {
            fill: o,
            d: "M11.992 6.577c-.698 0-1.241-.185-1.617-.546-.392-.378-.59-.936-.59-1.664 0-.728.198-1.289.59-1.667.376-.364.92-.549 1.617-.549s1.243.185 1.621.55c.393.377.591.94.591 1.666 0 .725-.198 1.286-.59 1.664-.379.361-.925.546-1.622.546zM10.952 3.3c-.224.215-.336.574-.336 1.067s.112.849.334 1.064c.215.208.565.314 1.042.314.476 0 .826-.106 1.044-.314.225-.213.337-.571.337-1.061 0-.493-.115-.852-.34-1.067-.218-.21-.568-.317-1.041-.317-.474 0-.824.106-1.04.314zm-2.047 6.857h6.182v-.154c0-.336-.07-.813-.403-1.16-.37-.386-.936-.465-1.342-.465h-2.695c-.409 0-.972.081-1.342.465-.333.345-.4.824-.4 1.16v.154zm-.583.835a.253.253 0 01-.252-.253v-.736c0-.703.219-1.306.633-1.737.451-.47 1.123-.72 1.941-.72h2.695c.818 0 1.49.25 1.944.72.415.434.636 1.034.636 1.737v.736c0 .138-.112.25-.25.253H8.322zM4.7 15.212c0 .494.112.85.334 1.065.215.208.565.314 1.042.314.476 0 .826-.104 1.042-.314.224-.215.336-.571.336-1.061s-.112-.85-.336-1.065c-.219-.21-.569-.316-1.042-.316-.477-.003-.827.103-1.042.31-.222.216-.334.575-.334 1.068zm1.373 2.211c-.698 0-1.241-.185-1.62-.546-.391-.378-.587-.936-.587-1.664 0-.726.198-1.286.588-1.664.375-.364.921-.549 1.619-.549.697 0 1.244.185 1.619.549.392.378.59.941.59 1.667 0 .725-.198 1.285-.59 1.664-.375.358-.919.543-1.62.543zm3.095 3.426c0-.336-.07-.813-.403-1.157-.37-.384-.936-.465-1.345-.465H4.728c-.409 0-.975.081-1.339.465-.333.347-.4.82-.4 1.16v.154c-.003-.003 6.179-.003 6.179-.003v-.154zM7.42 18.392c.82 0 1.493.25 1.944.72.417.434.636 1.036.636 1.737v.736c0 .14-.112.252-.252.252H2.403a.251.251 0 01-.252-.252v-.736c0-.703.219-1.303.633-1.737.451-.47 1.124-.723 1.941-.723l2.695.003zm9.118-3.185c0 .493.112.849.333 1.062.216.207.566.314 1.04.314.476 0 .826-.107 1.044-.314.224-.216.336-.571.336-1.062 0-.493-.112-.849-.336-1.067-.218-.207-.568-.314-1.045-.314-.473 0-.823.107-1.039.314-.221.216-.333.574-.333 1.067zm-.247 1.664c-.392-.378-.588-.935-.588-1.664 0-.728.196-1.288.588-1.666.376-.364.922-.55 1.616-.55.698 0 1.244.186 1.622.55.395.378.591.938.591 1.666 0 .726-.198 1.286-.59 1.664-.379.362-.922.546-1.623.546-.694 0-1.24-.184-1.616-.546zm4.715 3.972c0-.336-.07-.812-.404-1.157-.37-.384-.935-.465-1.344-.465h-2.692c-.41 0-.972.081-1.34.465-.333.348-.4.821-.4 1.16V21h6.18v-.157zm.193-1.737c.417.435.638 1.034.638 1.737v.737a.25.25 0 01-.252.252h-7.344a.251.251 0 01-.252-.252v-.737c0-.703.218-1.305.633-1.737.45-.47 1.123-.72 1.941-.72h2.695c.818 0 1.49.25 1.94.72zm-7.297-2.585a.418.418 0 00.437-.712l-1.941-1.187v-2.258a.418.418 0 00-.835 0v2.258l-1.944 1.19a.414.414 0 00-.137.572.414.414 0 00.571.137l1.925-1.177 1.924 1.177z"
        })
    }));
}, M = i;
export { M as default };
